import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromApiKey from './api-key.reducer';

export const selectApiKeyState = createFeatureSelector<fromApiKey.ApiKeysState>(fromApiKey.apiKeyFeatureKey);

export const selectApiKeys = createSelector(selectApiKeyState, (state) => state.apiKeys);
export const selectApiKeyCreateForm = createSelector(selectApiKeyState, (state) => state.apiKeyCreateForm);
export const selectApiKeysFilter = createSelector(selectApiKeyState, (state) => state.apiKeysFilter);
export const selectApiKeysPagination = createSelector(selectApiKeyState, (state) => state.pagination);
export const selectApiKeysQuery = createSelector(selectApiKeyState, (state) => state.query);
export const selectIsLoading = createSelector(selectApiKeyState, (state) => state.isLoading);
export const selectMemberApiKeysEnabled = createSelector(selectApiKeyState, (state) => state.memberApiKeysEnabled);
export const selectApiKeysMemberUsername = createSelector(selectApiKeyState, (state) => state.memberUsername);
